import apiConfig from "./base/apiConfig";
export const BASE_URL = `${apiConfig}`;